import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { LoaderService } from '@loader';
import * as Api from '@interfaces/api';

@Injectable({
  providedIn: 'root'
})
export class HttpService {
  constructor(
    private $http: HttpClient,
    private $loader: LoaderService,
  ) { }

  async get<T = any>(url: string, options: Api.Options = {}): Promise<Api.Response<T>> {
    if (!options.skipLoader) { // Default Loader will start
      this.$loader.markAsLoading();
    }
    try {
      const resp = await this.$http.get<Api.Response<T>>(url, options).toPromise();
      return resp;
    } finally {
      if (!options.skipLoader) {
        this.$loader.completeLoading();
      }
    }
  }

  async post<T = any>(url: string, body: object, options: Api.Options = {}): Promise<Api.Response<T>> {
    if (!options.skipLoader) { // Default Loader will start
      this.$loader.markAsLoading();
    }
    try {
      const resp = await this.$http.post<Api.Response<T>>(url, body, options).toPromise();
      return resp;
    } finally {
      if (!options.skipLoader) {
        this.$loader.completeLoading();
      }
    }
  }

  async put<T = any>(url: string, body: object, options: Api.Options = {}): Promise<Api.Response<T>> {
    if (!options.skipLoader) { // Default Loader will start
      this.$loader.markAsLoading();
    }
    try {
      const resp = await this.$http.put<Api.Response<T>>(url, body, options).toPromise();
      return resp;
    } finally {
      if (!options.skipLoader) {
        this.$loader.completeLoading();
      }
    }
  }

  async patch<T = any>(url: string, body: object, options: Api.Options = {}): Promise<Api.Response<T>> {
    if (!options.skipLoader) { // Default Loader will start
      this.$loader.markAsLoading();
    }
    try {
      const resp = await this.$http.patch<Api.Response<T>>(url, body, options).toPromise();
      return resp;
    } finally {
      if (!options.skipLoader) {
        this.$loader.completeLoading();
      }
    }
  }

  async delete<T = any>(url: string, options: Api.Options = {}): Promise<Api.Response<T>> {
    if (!options.skipLoader) { // Default Loader will start
      this.$loader.markAsLoading();
    }
    try {
      const resp = await this.$http.delete<Api.Response<T>>(url, options).toPromise();
      return resp;
    } finally {
      if (!options.skipLoader) {
        this.$loader.completeLoading();
      }
    }
  }
}
